import { Formik } from "formik";
import { Button } from "@mui/material";
import CustomField from "../../shared/CustomTextField";
import { useStore } from "../../../hooks/store";
import Styles from "../Form.module.css";
import { postTheme, updateTheme } from "../../../utils/API/themeMethods";
import { useState } from "react";

export default function ThemeForm() {
  const store = useStore();
  const themeData = store.form.dataToUpdate;
  const [initValues, setValues] = useState(
    themeData || {
      id: "",
      name: "",
      description: "",
      theme_number: null,
      master_theme_id: null,
      theme_subnumber: null,
    }
  );

  const submitTheme = (values) => {
    postTheme(values).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const submitUpdatedTheme = (values) => {
    updateTheme(values, values.id).then(({ data, status }) => {
      if (status === 200) {
        store.closeForm();
        store.setAlert(data, "success");
        store.form.callBack();
        return;
      }

      store.setAlert(data, "error");
    });
  };

  const wrapperStyle = themeData && { flexDirection: "row" };

  return (
    <Formik
      initialValues={initValues}
      onSubmit={(values, { setSubmitting }) => {
        setSubmitting(true);
        if (themeData) {
          submitUpdatedTheme(values);
        } else {
          submitTheme(values);
        }

        setSubmitting(false);
      }}>
      {({
        values,
        errors,
        touched,
        handleChange,
        handleBlur,
        handleSubmit,
        isSubmitting,
        handleReset,
        submitForm,
        setFieldValue,
        /* and other goodies */
      }) => (
        <>
          <p>{themeData ? "Изменение темы" : "Создание темы"}</p>
          <form onSubmit={handleSubmit}>
            <div
              className={Styles.form_content}
              style={{ ...wrapperStyle, width: "350px" }}>
              <div className={Styles.form_fields}>
                <CustomField
                  name="theme_number"
                  label="Номер темы"
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.theme_number}
                  disabled={values.master_theme_id}
                />
                {values.master_theme_id && (
                  <CustomField
                    name="theme_subnumber"
                    label={"Подномер темы"}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.theme_subnumber}
                  />
                )}
                <CustomField
                  multiline
                  rows={2}
                  name="name"
                  label={
                    values.master_theme_id
                      ? "Название подтемы"
                      : "Название темы"
                  }
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.name}
                />

                <CustomField
                  multiline
                  rows={3}
                  name="description"
                  label={"Описание "}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.description}
                />
              </div>
            </div>
            <div className="form_actions">
              {!values.master_theme_id && (
                <Button
                  disabled
                  onClick={() => {
                    setFieldValue("master_theme_id", themeData.id);
                    setFieldValue("name", "");
                  }}>
                  Добавить подтему
                </Button>
              )}
              <Button onClick={handleReset}>Очистить</Button>
              <Button variant="contained" onClick={handleSubmit}>
                Применить
              </Button>
            </div>
          </form>
        </>
      )}
    </Formik>
  );
}
